interface Props {
  children: string
}

const Description = ({ children }: Props) => (
  <p className="description mb-4">{children}</p>
)

export default Description
